<template>
  <div id="app">
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  metaInfo: {
    title: "Viewmed La Medicina Digitactil",
    meta: [
      {
        name: "description",
        content:
          "Viewmed el sistema integrado de salud que acelera la transformación de los servicios médicos de analógicos a digitales creando la medicina DIGITATIL"
      }
    ]
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/App.vue